// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2KWBa","inputDescription":"styles_inputDescription__3xFBM"};